import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import {
  reserveProjectStepTasksPath,
  submitAnswerProjectStepTasksPath,
} from '../../cross-team-shared/hub-paths';
import { UrlRequestService } from '../../cross-team-shared/misc-services/resources/url-request.service';
import { AnswersByName } from '../../team-apis/otterdam/answers/answer';
import { AutoQaScriptAfterValidation } from '../../team-apis/otterdam/auto-qa-response';
import { RedirectResponse } from '../../team-apis/otterdam/redirect-response';
import { QaFeedback, TaskExternal } from '../../team-apis/otterdam/task';

export interface SubmitAnswerRequestOptions {
  projectId: number;
  stepId: number;
  taskId: string;
  answers: AnswersByName;
  nextInternalId: number;
  duration: number;
  autoQaScriptsAfterValidation?: AutoQaScriptAfterValidation[];
  qa_feedback?: QaFeedback;
  qaGroupId: string;
  token: string;
}

@Injectable({ providedIn: 'root' })
export class TaskResource extends UrlRequestService {
  private preloadedTask: TaskExternal | undefined;

  submit_answer(options: SubmitAnswerRequestOptions) {
    return this.request<TaskExternal | RedirectResponse>(
      'POST',
      `${environment.sh3BaseUrl}${submitAnswerProjectStepTasksPath(
        options.projectId,
        options.stepId,
      )}`,
      {
        body: {
          task_id: options.taskId,
          answers: JSON.stringify(options.answers),
          next_internal_id: options.nextInternalId,
          duration: options.duration,
          auto_qa_scripts: options.autoQaScriptsAfterValidation,
          qa_feedback: options.qa_feedback,
        },
        params: { qa_group_id: options.qaGroupId },
        headers: { Authorization: `Bearer ${options.token}` },
      },
    );
  }

  reserveTask(
    projectId: number,
    stepId: number,
    qaGroupId: string,
    token: string,
  ) {
    if (this.preloadedTask) {
      const task = this.preloadedTask;
      this.preloadedTask = undefined;
      return task;
    }

    return this.request<TaskExternal | RedirectResponse>(
      'POST',
      `${environment.sh3BaseUrl}${reserveProjectStepTasksPath(projectId, stepId)}`,
      {
        params: { qa_group_id: qaGroupId },
        body: '',
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }

  setNextReservedTask(task: TaskExternal) {
    this.preloadedTask = task;
  }
}
